import { Link } from "react-router-dom";

const exploreLinks = [
  { to: "/category/movie", label: "电影频道" },
  { to: "/category/tv", label: "电视剧频道" },
  { to: "/news", label: "影视资讯" },
  { to: "/search", label: "搜索作品" },
];

const aboutLinks = [
  { to: "/about", label: "关于我们" },
  { to: "/about", label: "联系方式" },
  { to: "/about", label: "使用说明" },
  { to: "/about", label: "版权声明" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 text-background-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2 lg:max-w-md">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-film-line text-lg"></i>
              </span>
              <span className="font-heading font-semibold text-white text-base">
                聚会的目的<span className="text-accent-400">在线</span>
              </span>
            </div>
            <p className="text-sm leading-relaxed text-primary-100">
              聚会的目的在线致力于为影视爱好者提供丰富的电影与电视剧资源，涵盖剧情介绍、演员表与影视资讯，
              帮助你更轻松地发现、了解并收藏喜欢的作品。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <span className="w-9 h-9 rounded-md bg-primary-800 flex items-center justify-center text-primary-100 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="w-9 h-9 rounded-md bg-primary-800 flex items-center justify-center text-primary-100 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-9 h-9 rounded-md bg-primary-800 flex items-center justify-center text-primary-100 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-mail-line"></i>
              </span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">浏览探索</h4>
            <ul className="space-y-2.5">
              {exploreLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-primary-100 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">关于平台</h4>
            <ul className="space-y-2.5">
              {aboutLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-primary-100 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-primary-200">
            © 2024 聚会的目的在线 · 本站内容为演示示例，仅供学习交流使用。
          </p>
          <p className="text-xs text-primary-200">
            聚合优质影视资讯 · 结构清晰 · 浏览舒适
          </p>
        </div>
      </div>
    </footer>
  );
}